import { createContext, useContext } from "react";
import { IAppSettingPageStore } from "../types/AppSettingPageTypes";
import { CreditProviderItemStore } from "./CreditProviderItemStore";
import { OrganisationProviderStore } from "./OrganisationProviderStore";
import { CreditProviderListStore } from "./CreditProviderListStore";
import { CreditProviderProductStore } from "./CreditProviderProductStore";

export const appSettingStore: IAppSettingPageStore = {
	creditProviderListStore: new CreditProviderListStore(),
	creditProviderItemStore: new CreditProviderItemStore(),
	organisationProviderStore: new OrganisationProviderStore(),
	creditProviderProductStore: new CreditProviderProductStore(),
}

export const AppSettingStoreContext = createContext<IAppSettingPageStore>(appSettingStore);

export const useAppSettingStore = (): IAppSettingPageStore => {
	const store = useContext(AppSettingStoreContext);
	if (!store) {
		throw new Error('useAppSettingPageStore must be used within a AppSettingPageStoreProvider');
	}
	return store;
}